var map = {
	"./01.svg": "3be6",
	"./02.svg": "ffe0",
	"./03.svg": "29aa",
	"./04.svg": "672c",
	"./Calendar.svg": "419d",
	"./Group.svg": "73a2",
	"./Group@2x.svg": "4c9f",
	"./Group@3x.svg": "fe9f",
	"./Icon-Alert.svg": "2f98",
	"./Protection.svg": "3418",
	"./Smartphone.svg": "ca21",
	"./add.svg": "b3c0",
	"./alert.svg": "4c89",
	"./arrow-horizontal-purple.svg": "a4ef",
	"./arrow-horizontal.svg": "8146",
	"./btn-close.svg": "e3d8",
	"./cel-imei.svg": "444b",
	"./check.svg": "4a24",
	"./chevron-up.svg": "6003",
	"./ciclic-negativo.svg": "8833",
	"./ex-nota-fiscal.svg": "4696",
	"./facebook.svg": "7e4b",
	"./find-document.svg": "19ea",
	"./folha-de-s-paulo.svg": "ce8d",
	"./frontal-white.svg": "a82b",
	"./g-8.svg": "7fb8",
	"./glasses.svg": "1d69",
	"./icon-blocked.svg": "e7f4",
	"./icon-broken-contract-green.svg": "5d17",
	"./icon-broken-gray.svg": "e462",
	"./icon-calendar-purple.svg": "af81",
	"./icon-cellphone-purple.svg": "5994",
	"./icon-celular-gray-with-shield.svg": "65f5",
	"./icon-celular-green-success.svg": "662a",
	"./icon-check.svg": "e179",
	"./icon-chevron-left.svg": "723e",
	"./icon-copy-purple.svg": "93d4",
	"./icon-coverage-purple.svg": "8362",
	"./icon-credit-card.svg": "b07e",
	"./icon-device-cellphone.svg": "5a00",
	"./icon-device-notebook.svg": "7be3",
	"./icon-device-smartwatch.svg": "1047",
	"./icon-device-tablet.svg": "f22f",
	"./icon-devices-green.svg": "2a55",
	"./icon-devices.svg": "ee61",
	"./icon-document-purple.svg": "8b0d",
	"./icon-exterior-gray.svg": "f233",
	"./icon-facebook-gray.svg": "0668",
	"./icon-gift.svg": "062d",
	"./icon-linkedin-gray.svg": "76b3",
	"./icon-liquid-gray.svg": "9544",
	"./icon-notebook-gray-with-shield.svg": "5ed0",
	"./icon-notebook-green-success.svg": "76bf",
	"./icon-pix-purple.svg": "2026",
	"./icon-play.svg": "1f8f",
	"./icon-plus-purple.svg": "8b96",
	"./icon-robbery-gray.svg": "5061",
	"./icon-shield-green.svg": "b385",
	"./icon-smartwatch-gray-with-shield.svg": "8132",
	"./icon-smartwatch-green-success.svg": "afc0",
	"./icon-success-purple.svg": "d7df",
	"./icon-success.svg": "8603",
	"./icon-tablet-gray-with-shield.svg": "9e67",
	"./icon-tablet-green-success.svg": "6474",
	"./icon-theft-gray.svg": "a36d",
	"./icon-validity-purple.svg": "ebdd",
	"./icon-whatsapp-gray.svg": "07e2",
	"./iconAlerttwo (1).svg": "523e",
	"./icone-codigo.svg": "97e0",
	"./icone-data.svg": "23be",
	"./icone-duvida.svg": "615d",
	"./icone-exterior.svg": "b3b8",
	"./icone-liquido.svg": "112d",
	"./icone-pdf.svg": "9d77",
	"./icone-protecao.svg": "97b8",
	"./icone-quebra.svg": "93e4",
	"./icone-roubo.svg": "936c",
	"./icone-sucesso.svg": "0626",
	"./icone-tempo.svg": "0894",
	"./icons-general-gift.svg": "73b9",
	"./icons-general-money.svg": "0bff",
	"./icons-general-protection.svg": "a8fc",
	"./icons-status-cancel.svg": "34cd",
	"./icons-status-success.svg": "8bf5",
	"./icons-time.svg": "7f11",
	"./instagram.svg": "48d6",
	"./laptop-money-banknote.svg": "1aaa",
	"./line.svg": "7fe7",
	"./loader-dark.svg": "9268",
	"./loader.svg": "9432",
	"./lock-checkmark-square.svg": "068e",
	"./mc-symbol.svg": "9f264",
	"./minilogo-positivo.svg": "2247",
	"./notetabletsmart.svg": "cf1f",
	"./path.svg": "f071",
	"./protected-bag-icon-1.svg": "3e18",
	"./protected-bag-icon-2.svg": "7eac",
	"./protected-bag-icon-3.svg": "7410",
	"./protected-bag-icon-4.svg": "60a8",
	"./protected-bag-icon-5.svg": "d259",
	"./protected-bag-icon-6.svg": "5125",
	"./protected-bag-icon-7.svg": "de86",
	"./protected-bag-icon-8.svg": "d4fc",
	"./seguro-portateis.svg": "c5e0",
	"./sem-multa-2.svg": "c1ab",
	"./sem-multa-4.svg": "582c",
	"./sem-multa.svg": "0c23",
	"./sem-multa1.svg": "92a4",
	"./seta.svg": "bedd",
	"./seta_rosa.svg": "3433",
	"./shape.svg": "2d11",
	"./shape_positivo.svg": "2998",
	"./toast-warning.svg": "f1cd",
	"./twitter.svg": "5a0b",
	"./ver-mais.svg": "64f5",
	"./wallet-credit-card.svg": "422e",
	"./warning-confirm.svg": "0401",
	"./warning.svg": "45a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";